//on document loaded
$(document).ready(function() {
  //on filter bar select change,submit parent form
  console.log("form ready");
  $(".filter-bar-houses select").on("change", function() {
    //views-rows fade in and create loader
    $(".loader-container").fadeIn(500);
    $(".views-rows").css("opacity", "0");

    //console log select name and option
    console.log("select changed");
    console.log($(this).attr("name"));
    console.log($(this).val());
    if ($(this).attr("name") == "house_model") {
      //redirect to val
      //get current url
      var url = window.location.href;
      console.log(url);
      window.location.href = url + "/" + $(this).val();
    } else {
      $(this)
        .closest("form")
        .submit();
    }
  });
});
